import Vue from 'vue'
import Router from 'vue-router'

import Accueil from '../components/Accueil'
import Admin from '../components/admin/Admin'
import Arbitres from '../components/arbitres/Arbitres'
import Articles from '../components/articles/Articles'
import Buteurs from '../components/buteurs/Buteurs'
import Matchs from '../components/matchs/Matchs'
import Cartons from '../components/cartons/Cartons'
import Championnats from '../components/championnats/Championnats'
import Classements from '../components/classements/Classements'
import Equipes from '../components/equipes/Equipes'
import Joueurs from '../components/joueurs/Joueurs'
import Messages from '../components/messages/Messages'
import Resultats from '../components/resultats/Resultats'
import Staffs from '../components/staffs/Staffs'
import Terrains from '../components/terrains/Terrains'
import Saisons from "../components/saisons/Saisons";
import Login from "../components/Login";


Vue.use(Router)

export const routes = {
  routes: [
    { path: '/', name: 'Accueil', component: Accueil},
    { path: '/login', name: 'Login', component: Login},
    { path: '/admin', name: 'Admin', component: Admin },
    { path: '/arbitres', name: 'Arbitres', component: Arbitres },
    { path: '/articles', name: 'Articles', component: Articles },
    { path: '/buteurs', name: 'Buteurs', component: Buteurs },
    { path: '/championnats', name: 'Championnats', component: Championnats },
    { path: '/classements', name: 'Classements', component: Classements },
    { path: '/equipes', name: 'Equipes', component: Equipes },
    { path: '/joueurs', name: 'Joueurs', component: Joueurs },
    { path: '/matchs', name: 'Matchs', component: Matchs },
    { path: '/messages', name: 'Messages', component: Messages },
    { path: '/resultats', name: 'Resultats', component: Resultats },
    { path: '/staffs', name: 'Staffs', component: Staffs },
    { path: '/terrains', name: 'Terrains', component: Terrains },
    { path: '/saisons', name: 'Saisons', component: Saisons },
    { path: '/cartons', name: 'Cartons', component: Cartons },
  ],
  mode: 'history',
}

const router = new Router(routes);

/*
router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem("token")){
    next()
  }else {
    next(false)
  }
})
*/

export default router;

/*
export default new Router({
  routes: [
    { path: '/', name: 'Accueil', component: Accueil},
    { path: '/login', name: 'Login', component: Login},
    { path: '/admin', name: 'Admin', component: Admin },
    { path: '/arbitres', name: 'Arbitres', component: Arbitres },
    { path: '/articles', name: 'Articles', component: Articles },
    { path: '/buteurs', name: 'Buteurs', component: Buteurs },
    { path: '/championnats', name: 'Championnats', component: Championnats },
    { path: '/classements', name: 'Classements', component: Classements },
    { path: '/equipes', name: 'Equipes', component: Equipes },
    { path: '/joueurs', name: 'Joueurs', component: Joueurs },
    { path: '/matchs', name: 'Matchs', component: Matchs },
    { path: '/messages', name: 'Messages', component: Messages },
    { path: '/resultats', name: 'Resultats', component: Resultats },
    { path: '/staffs', name: 'Staffs', component: Staffs },
    { path: '/terrains', name: 'Terrains', component: Terrains },
    { path: '/saisons', name: 'Saisons', component: Saisons },
    { path: '/cartons', name: 'Cartons', component: Cartons },
  ],
  mode: 'history',
})
*/



// WEBPACK FOOTER //
// ./src/router/index.js